export const ApiDef_SmartDoc = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map